import SimpleStore from 'src/store/SimpleStore';
import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';
import {
  HTTP_HEADER_KEYS,
  HTTP_URL_PARAMS
} from 'src/utils/constants/HttpMethodsConstants';

import { LAPSER_AND_ADVRENEWAL_DATA_QUERY } from '../GraphQL/Queries/LapserDetails';
import { graphQlRequest } from '../GraphQL/RequestHandler';

export const fetchLapserAdvanceRenewalDetails = async () => {
  const country = SimpleStore.get(HTTP_URL_PARAMS.COUNTRY_CODE);
  const requestParams = {
    country
  };

  try {
    const response: any = await graphQlRequest(
      LAPSER_AND_ADVRENEWAL_DATA_QUERY,
      requestParams,
      GQL_QUERIES.LAPSER_AND_ADVANCE_RENEWAL,
      [HTTP_HEADER_KEYS.AUTHORIZATION, HTTP_HEADER_KEYS.X_ACCESS_TOKEN]
    );
    return response;
  } catch (error) {
    console.error('Error while fetching lapser details: ', error);
    return {};
  }
};
